export default ({ theme, ...rest }) => {
	const { textColor } = rest;
	let returnStyle = '';
	// Handle Text Color
	if (textColor && typeof textColor === 'string') {
		if (textColor === 'default' || !theme[textColor]) {
			returnStyle += `color: ${theme.defaultColor} !important;`;
		}
		returnStyle += `color: ${theme[textColor]} !important;`;
	}
	return returnStyle;
};
